import { render } from "./card-list-item-parent.vue?vue&type=template&id=390a8f96"
import script from "./card-list-item-parent.vue?vue&type=script&lang=js"
export * from "./card-list-item-parent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__